import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  /**
   * Current selected module
   * @type {{name:String, email:String, title:String}}
   */
  user: undefined,
  userContracts: [],
  userPermissions: [],
  unConstructedUserPermissions: [],
  keycloak: null
};

export default {
  actions,
  mutations,
  getters,
  state,
  namespaced: true
};
